/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_Import_Default_PaidInputs */



/**
* | output |
* | --- |
* | "Mark imported players as Paid (they paid at the ticketing source)" |
*
* @param {Csv_Import_Default_PaidInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_default_paid = /** @type {((inputs?: Csv_Import_Default_PaidInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_Default_PaidInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marquer les joueurs importés comme Payé (ils ont déjà payé via la billetterie)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcar a los jugadores importados como Pagado (ya pagaron en la plataforma de venta de entradas)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Marcar os jogadores importados como Pago (eles já pagaram na bilheteria)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segna i giocatori importati come Pagato (hanno già pagato tramite la biglietteria)")
	return /** @type {LocalizedString} */ ("Mark imported players as Paid (they paid at the ticketing source)")
});